import {SiteType} from "./Link";
import {MENTIONS_SITE_TYPE} from "./Package";

export interface OrderTaskBody {
    linkingSiteId?: string;
    anchor?: string;
    anchorLink?: string;
    scheduledTime: string;
    secondAnchor?: string;
    secondAnchorLink?: string;
    preciseAnchor?: boolean;
    // mentions only: the backend requires it on a mention task and rejects it
    // on a link one, so it is never sent outside the mentions branch
    query?: string;
}

export interface AdminOrderTaskUpdateLinkingSiteBody {
    linkingSiteId: string;
}

export interface OrderCategory {
    id: string;
    name: string;
}

export interface OrderTask {
    id: string;
    linkingSite?: {
        id: string;
        hostname: string;
        type: SiteType;
    };
    status: OrderTaskStatus;
    anchor?: string;
    anchorLink?: string;
    secondAnchor?: string;
    secondAnchorLink?: string;
    orderTime: string;
    scheduledTime: string;
    createdAt: string;
    updatedAt: string;
    siteType: string; // to identify package site type
    articleUrl?: string;
    category?: OrderCategory;
    subCategories?: OrderCategory[];
    usersContent?: boolean;
    documentUrl?: string;
    preciseAnchor?: boolean;
    // mentions only: the search query the mention has to answer, the catalog the
    // linking site is picked from ('boost' | 'super' | 'premium') and the anchor
    // type the backend fixes to 'brand'
    query?: string;
    catalogSiteType?: string;
    anchorType?: string;
}

// A mention task keeps its package's siteType, which is how every surface tells
// a mention deliverable from a link one.
export const isMentionTask = (task: Pick<OrderTask, 'siteType'>) => task.siteType === MENTIONS_SITE_TYPE;

export const isMentionOrder = (order: { tasks: Pick<OrderTask, 'siteType'>[] }) =>
    order.tasks.length > 0 && order.tasks.every(isMentionTask);

interface Order {
    id: string;
    itemType: string;
    tasks: OrderTask[];
    status: string;
    totalPrice: number;
    createdAt: string;
    updatedAt: string;
    user?: {
        id?: string;
        email?: string;
    };
    allowSecondAnchor: boolean;
}


export interface EditableOrderTask extends OrderTask {
    linkingSiteId: string | undefined;
    linkingSiteHostname: string | undefined;
}

export interface EditableOrder extends Order{
    tasks: EditableOrderTask[];
}

export enum OrderTaskStatus {
    PENDING = "pending",
    PENDING_DATA = "pending_data",
    SENT = "sent",
    IN_PROGRESS = "in_progress",
    COMPLETED = "completed",
}

export default Order